<h5 nxHeadline="subsection-medium" class="align-center">{{data.title | translate}}</h5>
<form [formGroup]="parentForm" class="formClass">
  <qbe-panel-component>
    <div nxRow class="wrapper-panel-component nx-margin-top-3xl  margin-box">
      <div nxCol="12, 12, 7" class="left-container">
        <h2 class="left-container-heading">{{data['heading'] | translate}}</h2>
        <div *ngIf="data.subHeading">
          <span class="enter-phone  translated-paragraph">{{data.subHeading | translate}}</span>
        </div>
        <div class="nx-margin-top-3xl">
          <qbe-illustration *ngIf="data.image" [name]="data.image" class="outer-top-element-left-illustration">
          </qbe-illustration>
        </div>
      </div>
      <div nxCol="12, 12, 5" [ngStyle]="{'padding-bottom': (data.rightPaddingBottom)}">
        <ng-container formGroupName="ownerData">

          <nx-formfield label="{{'details4.pid' | translate}}">
            <input digitOnly required nxInput formControlName="egn"
            (blur)="resetOnerData()"
            (blur)="this.trackService.checkErrors( parentForm.controls.ownerData.controls.egn, 'Owner Tax/Personal ID')" 

            >
            <nx-error class="field-error" nxFormfieldError appearance="text">
              {{'error.invalidOwner' | translate}}
            </nx-error>
          </nx-formfield>

          <nx-formfield *ngIf="isCompany===false" [label]="'registeredCar.name' | translate">
            <input nxInput formControlName="firstName" pattern="[а-яА-ЯЁё]*"
            (change)="setUserTracking(parentForm.controls.ownerData.controls.firstName.value, 'firstName')"
            (change)="this.trackService.checkErrors( parentForm.controls.ownerData.controls.firstName, 'Owner first name')" 
            >
          </nx-formfield>

          <nx-formfield *ngIf="isCompany===false" [label]="'registeredCar.middleName' | translate">
            <input nxInput formControlName="middleName" pattern="[а-яА-ЯЁё]*"
            (change)="this.trackService.checkErrors( parentForm.controls.ownerData.controls.middleName, 'Owner middle name')" 

            >
          </nx-formfield>

          <nx-formfield *ngIf="isCompany===false" [label]="'registeredCar.surname' | translate">
            <input nxInput formControlName="lastName" pattern="[а-яА-ЯЁё]*"
            (change)="setUserTracking (parentForm.controls.ownerData.controls.lastName.value, 'lastName')"
            (change)="this.trackService.checkErrors( parentForm.controls.ownerData.controls.lastName, 'Owner last name')" 

            >
          </nx-formfield>

          <nx-formfield *ngIf="isCompany===true" [label]="'registeredCar.name' | translate">
            <input nxInput formControlName="companyName"
            (change)="this.trackService.checkErrors( parentForm.controls.ownerData.controls.companyName, 'Owner name')" 
            >
          </nx-formfield>

          <!-- <nx-formfield>
                <nx-dropdown
                [showFilter]="true"
                class="phone-code"
                formControlName="countryCode"
              >
                <nx-dropdown-item
                  *ngFor="let item of phoneCodes"
                  [value]="'+' + item"
                  (click)="this.parentForm.controls.samePerson.value == 'Y' ? this.trackService.pushEventTracking('user.mobilePhone', parentForm.controls.ownerData.controls.countryCode.value+parentForm.controls.ownerData.controls.phoneNumber.value) : ''"
                >
                  {{ "+" + item }}
                </nx-dropdown-item>
              </nx-dropdown>
              <input
                class="input-padding"
                maxlength='15'
                *ngIf="deactivateMask==false"
                [nxMask]="phoneMask"
                [separators]="phoneSeparator"
                [dropSpecialCharacters]="true"
                [pattern]="phonePattern"
                placeholder = "{{ 'registeredCar.phone' | translate }}"
                type="text"
                nxInput
                required
                formControlName="phoneNumber"
                (blur)="this.trackService.checkErrors( parentForm.controls.ownerData.controls.firstName, 'Owner mobile number')" 
                (blur)="this.parentForm.controls.samePerson.value == 'Y' ? this.trackService.pushEventTracking('user.mobilePhone', parentForm.controls.ownerData.controls.countryCode.value+parentForm.controls.ownerData.controls.phoneNumber.value) : ''"
              />
              <input
              class="input-padding"
              *ngIf="deactivateMask==true"
              maxlength='15'
              [separators]="phoneSeparator"
              [dropSpecialCharacters]="true"
              [pattern]="phonePattern"
              placeholder = "{{ 'registeredCar.phone' | translate }}"
              type="text"
              nxInput
              required
              formControlName="phoneNumber"
              (blur)="this.trackService.checkErrors( parentForm.controls.ownerData.controls.firstName, 'Owner mobile number')" 
              (blur)="this.parentForm.controls.samePerson.value == 'Y' ? this.trackService.pushEventTracking('user.mobilePhone', parentForm.controls.ownerData.controls.countryCode.value+parentForm.controls.ownerData.controls.phoneNumber.value) : ''"
            />

              <span nxFormfieldHint>+359 88 488 76хх</span>
          </nx-formfield> -->
          <!-- <nx-error *ngIf="(parentForm.get('ownerData.phoneNumber').errors && this.parentForm.get('ownerData.phoneNumber').value!==null) || (this.parentForm.get('ownerData.phoneNumber').value===null && this.parentForm.get('ownerData.phoneNumber').touched===true) || this.parentForm.get('ownerData.phoneNumber').value===''"
          class="field-error"
          appearance="text">
            {{ "error.errorMessage" | translate }}
          </nx-error> -->


          <nx-formfield>
            <app-phone-numbers [mobilePhone]="phoneNumber" [mobileCode]="countryCode" trackingPath="user.mobilePhone" >
            </app-phone-numbers>
            <span nxFormfieldHint>+35988 488 76xx</span>

        </nx-formfield>

          <nx-formfield [label]="'registeredCar.email' | translate">
            <input required nxInput formControlName="email" pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,5}"
            (change)="parentForm.controls.samePerson.value == 'Y'? trackService.pushEventTracking('user.emailAdress', parentForm.controls.ownerData.controls.email.value) : '' "
            (change)="setUserTracking(parentForm.controls.ownerData.controls.email.value, 'email')"
            (change)="this.trackService.checkErrors( parentForm.controls.ownerData.controls.email, 'User email address')" 
            >
            <span nxFormfieldHint>
              email&#64;domainname.com
            </span>
          </nx-formfield>

          <nx-formfield  *ngIf="hideAddress" [label]="'finalDetails.postCode' | translate">
            <nx-dropdown [valueFormatter]="toText" formControlName="postCode" [showFilter]="true"
                         [codes]="{postCodes:  (sharedService.$propertyCategories | async)?.postCodes}"
                         [filterPlaceholder]="'details1.postCode' | translate">
              <nx-dropdown-item *ngFor="let code of (sharedService.$propertyCategories | async)?.postCodes as postCodes"
                                [value]="code.value"
                                (click)="parentForm.controls.samePerson.value == 'Y'? trackService.pushEventTracking('user.postCode', code.value) : ''"
                                >{{code.value}}</nx-dropdown-item>
            </nx-dropdown>
          </nx-formfield>
          <nx-formfield *ngIf="hideAddress" [label]="'details1.city' | translate">
              <nx-dropdown [valueFormatter]="toText" formControlName="cityName" [showFilter]="false">
                <nx-dropdown-item *ngFor="let city of (sharedService.$propertyCategories | async)?.postCodes | filterCitiesByPostCode: parentForm.controls.ownerData"
                                  [value]="city.label"
                                  >{{city.label}}</nx-dropdown-item>
              </nx-dropdown>
            </nx-formfield>
          <nx-formfield  *ngIf="hideAddress" [label]="'registeredCar.streetAndNumber' | translate">
            <input nxInput formControlName="address"
            maxlength="80"
            minlength="3"
            pattern="[а-яА-ЯЁёIVX0-9-$&+,:;=?@#|^'<>.^*()%!№_-~\/\\[\]\x22 ]*"
            (change)="this.trackService.checkErrors( parentForm.controls.ownerData.controls.address, 'User address')" 

            >
          </nx-formfield>
        </ng-container>

      </div>
    </div>
  </qbe-panel-component>
</form>
